import { SYS4090_R01Dto } from "./Dto_SYS4090_R01";
import { useSYS4090_R01Store } from "./Store_SYS4090_R01";
import { InputForm } from "src/components/common/form/input/InputForm";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEffect, useState, useMemo } from "react";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { formatDate } from "src/utils/string/stringUtil";

interface Props {
	defaultSYS4090_R01Row: SYS4090_R01Dto;
}

export const Info_SYS4090_R01 = ({ defaultSYS4090_R01Row }: Props) => {
    const { editSYS4090_R01, selectedSYS4090_R01, setEditSYS4090_R01 } = useSYS4090_R01Store();
    const { bankCdList, bankAcctTypeList, interesttypeList, compCdList } = useCommonCodeStore();
    
    // 등록 모드와 수정 모드 구분
    // selectedBank가 있으면 수정 모드, 없고 editData만 있으면 등록 모드
    const isCreateMode = true && !selectedSYS4090_R01;

    
    // SingleDateForm에 필요한 state 변수들
    const [openPickerVisible, setOpenPickerVisible] = useState(false);
    const [openPickerPos, setOpenPickerPos] = useState({ top: 0, left: 0, height: 0 });
    const [maturityPickerVisible, setMaturityPickerVisible] = useState(false);
    const [maturityPickerPos, setMaturityPickerPos] = useState({ top: 0, left: 0, height: 0 });
    const [periodPickerVisible, setPeriodPickerVisible] = useState(false);
    const [periodPickerPos, setPeriodPickerPos] = useState({ top: 0, left: 0, height: 0 });

    // SYS3050 방식: 입력 값 변경 핸들러 (항상 편집 가능)
    const handleInputChange = (field: keyof SYS4090_R01Dto, value: any) => {
        if (editSYS4090_R01) {
            setEditSYS4090_R01({ ...defaultSYS4090_R01Row, ...editSYS4090_R01, [field]: value });
        }
    };

    return (
        <div className="w-full h-full flex flex-col border border-gray-300 px-[6px] py-[6px] overflow-x-auto">
			{/* editSYS4090_R01 : {JSON.stringify(editSYS4090_R01)} <br/> */}
            <InputForm 
                title="계좌코드" 
                value={editSYS4090_R01?.bankAcctCd ?? ''} 
                editable={isCreateMode} // 등록 모드에서만 편집 가능
                onChange={(e) => handleInputChange('bankAcctCd', e.target.value)}
            />
            <InputForm 
                title="계좌명" 
                value={editSYS4090_R01?.bankAcctNm ?? ''} 
                editable={true} // 등록 모드에서만 편집 가능
                onChange={(e) => handleInputChange('bankAcctNm', e.target.value)}
            />
            <InputForm 
                title="실제 계좌번호" 
                value={editSYS4090_R01?.bankAcctNo ?? ''} 
                editable={isCreateMode}
                onChange={(e) => handleInputChange('bankAcctNo', e.target.value)}
            />
            <DropDownForm 
                title="사업장명" 
                value={editSYS4090_R01?.compCd ?? ''} 
                data={compCdList} 
                name="compCd"
				initLabelLess={true}
                onChange={editSYS4090_R01 ? (e) => {
                    const selectedCompCd = e.target.value;
                    const selectedCompany = compCdList.find(comp => comp.compCd === selectedCompCd);
                    handleInputChange('compCd', selectedCompCd);
                    handleInputChange('codeNm', selectedCompany?.compNm || '');
                } : undefined}
            />
            <DropDownForm 
                title="은행명" 
                value={editSYS4090_R01?.bankCd ?? ''} 
                data={bankCdList} 
                name="bankCd"
				initLabelLess={true}
                onChange={editSYS4090_R01 ? (e) => handleInputChange('bankCd', e.target.value) : undefined}
            />
            <DropDownForm 
                title="예적금구분" 
                value={editSYS4090_R01?.acctType ?? ''} 
                data={bankAcctTypeList} 
                name="acctType"
				initLabelLess={true}
                onChange={editSYS4090_R01 ? (e) => handleInputChange('acctType', e.target.value) : undefined}
            />
            <SingleDateForm
					title="개설일자"
					value={editSYS4090_R01?.createDt ? new Date(editSYS4090_R01.createDt) : undefined}
					setValue={(date: Date | undefined) => handleInputChange('createDt', formatDate(date))}
					editable={true}
					visible={openPickerVisible}
					setVisible={setOpenPickerVisible}
					pickerPos={openPickerPos}
					setPickerPos={setOpenPickerPos}
				/>
            <SingleDateForm
					title="만기일자"
					value={editSYS4090_R01?.dueDt ? new Date(editSYS4090_R01.dueDt) : undefined}
					setValue={(date: Date | undefined) => handleInputChange('dueDt', formatDate(date))}
					editable={true}
					visible={maturityPickerVisible}
					setVisible={setMaturityPickerVisible}
					pickerPos={maturityPickerPos}
					setPickerPos={setMaturityPickerPos}
				/>
            <SingleDateForm
					title="적금납입일"
					value={editSYS4090_R01?.periodDt ? new Date(editSYS4090_R01.periodDt) : undefined}
					setValue={(date: Date | undefined) => handleInputChange('periodDt', formatDate(date))}
					editable={true}
					visible={periodPickerVisible}
					setVisible={setPeriodPickerVisible}
					pickerPos={periodPickerPos}
					setPickerPos={setPeriodPickerPos}
				/>
			
			<DropDownForm
					title="이자유형"	name="interesttype"		initLabelLess={true}	value={editSYS4090_R01?.interesttype || ''}		
					data={interesttypeList}
					onChange={(e) => handleInputChange('interesttype', e.target.value)} />
            {/* <div className="flex">
                <div className="flex-1"> */}
			<InputForm 
				title="이자율" 
				value={editSYS4090_R01?.interestrate ?? 0} 
				editable={true}
				onChange={(e) => handleInputChange('interestrate', e.target.value)}
				onBlur={(e) => {
					const value = e.target.value.replace(/,/g, '');
					const numValue = parseFloat(value) || 0;
					handleInputChange('interestrate', numValue);
				}}
			/>
			<InputForm 
				title="할부금액" 
				value={editSYS4090_R01?.installmentAmt ?? 0} 
				editable={true}
				onChange={(e) => handleInputChange('installmentAmt', e.target.value)}
				onBlur={(e) => {
					const value = e.target.value.replace(/,/g, '');
					const numValue = parseFloat(value) || 0;
					handleInputChange('installmentAmt', numValue);
				}}
			/>
			<InputForm 
				title="대출원금" 
				value={editSYS4090_R01?.loanamt ?? 0} 
				editable={true}
				onChange={(e) => handleInputChange('loanamt', e.target.value)}
				onBlur={(e) => {
					const value = e.target.value.replace(/,/g, '');
					const numValue = parseFloat(value) || 0;
					handleInputChange('loanamt', numValue);
				}}
			/>
			<InputForm 
				title="잔액" 
				value={editSYS4090_R01?.bankBalance ?? 0} 
				editable={true}
				onChange={(e) => handleInputChange('bankBalance', e.target.value)}
				onBlur={(e) => {
					const value = e.target.value.replace(/,/g, '');
					const numValue = parseFloat(value) || 0;
					handleInputChange('bankBalance', numValue);
				}}
			/>
                {/* </div>
            </div> */}
        </div>
    )
}